// extracted by mini-css-extract-plugin
export default {"auth_container":"AuthPage_auth_container__+a8Z5","auth_content":"AuthPage_auth_content__CG35l"};